<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg shadow-xl p-6 w-96">
    <h3 class="text-xl font-bold text-gray-800 mb-4">
      {{ getPaymentMethodName() }} - Valor
    </h3>
    
    <div class="space-y-4">
      <div class="bg-gray-50 p-4 rounded-md">
        <div class="text-sm text-gray-600 mb-2">Valor Restante:</div>
        <div class="text-lg font-semibold text-blue-600">{{ maxAmount | currency:'BRL' }}</div>
      </div>
      
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-2">Valor Pago</label>
        <input 
          #amountInput
          type="number" 
          step="0.01"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="0,00"
          [(ngModel)]="paymentAmount"
          (input)="onAmountChange()">
      </div>
      
      <div class="flex flex-col" *ngIf="paymentAmount > maxAmount">
        <label class="text-sm font-medium text-gray-700 mb-2">Troco</label>
        <div class="w-full px-3 py-2 bg-gray-100 rounded-md text-lg font-semibold text-orange-600">
          {{ (paymentAmount - maxAmount) | currency:'BRL' }}
        </div>
      </div>
      
      <div class="flex flex-col" *ngIf="paymentAmount > 0 && paymentAmount <= maxAmount">
        <label class="text-sm font-medium text-gray-700 mb-2">Restante</label>
        <div class="w-full px-3 py-2 bg-gray-100 rounded-md text-lg font-semibold text-red-600">
          {{ (maxAmount - paymentAmount) | currency:'BRL' }}
        </div>
      </div>
    </div>
    
    <div class="flex justify-end space-x-4 mt-6">
      <button 
        (click)="cancelPayment()"
        class="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
        Cancelar (ESC)
      </button>
      <button 
        (click)="confirm()"
        [disabled]="paymentAmount <= 0"
        class="px-6 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-400 disabled:cursor-not-allowed">
        Confirmar (F1)
      </button>
    </div>
  </div>
</div>
